import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useApolloClient } from '@vue/apollo-composable'
import { GET_CURRENT_USER } from '../graphql/queries'

type CurrentUser = {
  id: string
  email: string
  firstName: string
  lastName: string
}

export const useUserStore = defineStore('user', () => {
  const currentUser = ref<CurrentUser | null>(null)
  const loading = ref(false)

  const { client: apolloClient } = useApolloClient()

  /* ---------------------------
   * Fetch current user
   * --------------------------- */
  const fetchCurrentUser = async () => {
    loading.value = true
    try {
      const { data } = await apolloClient.query<{
        currentUser: CurrentUser
      }>({
        query: GET_CURRENT_USER,
        fetchPolicy: 'network-only',
      })

      currentUser.value = data.currentUser
    } catch (error) {
      console.error('Error fetching current user:', error)
      currentUser.value = null
    } finally {
      loading.value = false
    }
  }

  /* ---------------------------
   * Clear user (logout)
   * --------------------------- */
  const clearUser = () => {
    currentUser.value = null
    loading.value = false
  }

  return {
    currentUser,
    loading,
    fetchCurrentUser,
    clearUser,
  }
})
